import { Metadata } from '../../../entities/metadata';
import { MetadataProcessorInterface } from '../../../interfaces/components/processor/metadata/metadata-processor.interface';
import { Injectable } from '../../dependency-injection/decorators';
import { DoiProvider } from '../../provider/doi.provider';

@Injectable()
export class DoiMetadataProcessor implements MetadataProcessorInterface{
  constructor (private readonly doiProvider: DoiProvider) {
  }

  public async process (metadata: Metadata): Promise<void> {
    metadata.setDoi(this.doiProvider.provide());
  }
}
